(function(window) {
  'use strict';

  var MODULE_NAME = 'TPBDualFulfillment';
  var SOURCE_BRASIL = 'brasil';
  var SOURCE_INTERNACIONAL = 'internacional';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  function classifySource(value) {
    var normalized = normalize(value);

    if (normalized === 'brasil' || normalized === 'brazil' || normalized === 'br') {
      return SOURCE_BRASIL;
    }

    if (
      normalized === 'internacional' ||
      normalized === 'international' ||
      normalized === 'intl'
    ) {
      return SOURCE_INTERNACIONAL;
    }

    return '';
  }

  function setSwatchAvailability(radio, isAvailable) {
    radio.disabled = !isAvailable;

    var swatch = radio.nextElementSibling;
    if (!swatch || !swatch.classList.contains('tpb-swatch')) return;

    swatch.classList.toggle('is-sold-out', !isAvailable);
    swatch.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');

    if (isAvailable) {
      swatch.removeAttribute('title');
    } else {
      swatch.setAttribute('title', 'Esgotado');
    }
  }

  function create(config) {
    var wrapper = config && config.wrapper;
    var variants = config && config.variants;

    if (!wrapper || !Array.isArray(variants)) return null;
    if (wrapper.dataset.dualFulfillment !== 'true') return null;

    // 预售订单使用独立定金流程，不参与 BR / INTL 自动兜底。
    if (wrapper.dataset.preorderEnabled === 'true') {
      console.warn('[' + MODULE_NAME + '] 双仓元字段已开启，但当前商品为预售商品；双仓模块已跳过。');
      return null;
    }

    var originGroup = wrapper.querySelector('[data-tpb-option-role="fulfillment-origin"]');
    if (!originGroup) {
      console.warn('[' + MODULE_NAME + '] 未找到“Origem do envio”属性，已回退到原变体逻辑。');
      return null;
    }

    var originPosition = Number(originGroup.dataset.tpbOptionPosition);
    var originIndex = originPosition - 1;
    var originRadios = Array.prototype.slice.call(
      originGroup.querySelectorAll('.tpb-radio[data-pos="' + originPosition + '"]')
    );

    if (originIndex < 0 || originRadios.length === 0) {
      originGroup.hidden = false;
      console.warn('[' + MODULE_NAME + '] 发货来源属性配置不完整，已重新显示该属性并回退到原逻辑。');
      return null;
    }

    var sourceValues = {
      brasil: '',
      internacional: ''
    };

    originRadios.forEach(function(radio) {
      var source = classifySource(radio.value);
      if (source) sourceValues[source] = radio.value;
    });

    if (!sourceValues.brasil || !sourceValues.internacional) {
      originGroup.hidden = false;
      console.warn(
        '[' + MODULE_NAME + '] 发货来源必须同时包含 Brasil 和 Internacional，已回退到原变体逻辑。'
      );
      return null;
    }

    var allowedSourceValues = {};
    allowedSourceValues[sourceValues.brasil] = true;
    allowedSourceValues[sourceValues.internacional] = true;

    function variantMatchesSelections(variant, selected) {
      for (var index = 0; index < variant.options.length; index += 1) {
        if (index === originIndex) continue;
        if (selected[index] && variant.options[index] !== selected[index]) return false;
      }

      return true;
    }

    function findSourceVariant(selected, sourceValue) {
      return variants.find(function(variant) {
        return (
          variant.options[originIndex] === sourceValue &&
          variantMatchesSelections(variant, selected)
        );
      }) || null;
    }

    function resolve(selected) {
      var brasilVariant = findSourceVariant(selected, sourceValues.brasil);
      var internacionalVariant = findSourceVariant(selected, sourceValues.internacional);

      if (brasilVariant && brasilVariant.available) return brasilVariant;
      if (internacionalVariant && internacionalVariant.available) return internacionalVariant;

      // 两个来源都售罄时，优先返回 Brasil 变体以维持稳定的价格和规格显示。
      return brasilVariant || internacionalVariant || null;
    }

    function isVisibleOptionValueAvailable(selected, optionIndex, optionValue) {
      return variants.some(function(variant) {
        if (!variant.available) return false;
        if (!allowedSourceValues[variant.options[originIndex]]) return false;
        if (variant.options[optionIndex] !== optionValue) return false;

        // 与原产品页逻辑一致：只用当前属性之前的已选属性限制可售组合，
        // 避免后置属性反向锁死前置属性。
        for (var index = 0; index < optionIndex; index += 1) {
          if (index === originIndex) continue;
          if (selected[index] && variant.options[index] !== selected[index]) return false;
        }

        return true;
      });
    }

    function updateOptionAvailability(selected, radios) {
      Array.prototype.forEach.call(radios, function(radio) {
        var optionIndex = Number(radio.dataset.pos) - 1;

        // 发货来源是内部自动选择属性，不对顾客展示售罄状态，也不能禁用，
        // 否则其选中值可能不会进入 FormData。
        if (optionIndex === originIndex) {
          setSwatchAvailability(radio, true);
          return;
        }

        var isAvailable = isVisibleOptionValueAvailable(
          selected,
          optionIndex,
          radio.value
        );

        setSwatchAvailability(radio, isAvailable);
      });
    }

    function applyResolvedVariant(variant) {
      if (!variant) return;

      var sourceValue = variant.options[originIndex];
      var source = classifySource(sourceValue);
      var originRadio = originRadios.find(function(radio) {
        return radio.value === sourceValue;
      });

      if (originRadio) originRadio.checked = true;

      var originValueLabel = wrapper.querySelector('#val-' + originPosition);
      if (originValueLabel) originValueLabel.textContent = sourceValue;

      wrapper.dataset.activeFulfillment = source || '';
      wrapper.dataset.activeFulfillmentValue = sourceValue || '';
      wrapper.dataset.activeVariantId = String(variant.id || '');

      wrapper.dispatchEvent(new CustomEvent('tpb:dual-fulfillment-resolved', {
        bubbles: false,
        detail: {
          variant: variant,
          variantId: variant.id,
          source: source,
          sourceValue: sourceValue
        }
      }));
    }

    return {
      enabled: true,
      originIndex: originIndex,
      originPosition: originPosition,
      resolve: resolve,
      updateOptionAvailability: updateOptionAvailability,
      applyResolvedVariant: applyResolvedVariant,
      getSource: function(variant) {
        if (!variant) return '';
        return classifySource(variant.options[originIndex]);
      }
    };
  }

  window.TPBDualFulfillment = {
    create: create,
    normalize: normalize,
    classifySource: classifySource
  };
})(window);